import { render } from "./Duration.vue?vue&type=template&id=2229ec72"
import script from "./Duration.vue?vue&type=script&setup=true&lang=js"
export * from "./Duration.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Duration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2229ec72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2229ec72', __exports__)) {
    api.reload('2229ec72', __exports__)
  }
  
  module.hot.accept("./Duration.vue?vue&type=template&id=2229ec72", () => {
    api.rerender('2229ec72', render)
  })

}


export default __exports__